// src/index.ts
var cx = function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  return classNames.filter(Boolean).join(" ");
};

function isDev() {
  return process.env.NODE_ENV !== "production";
}

function isObject(value) {
  var type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

var warn = function warn(options) {
  var condition = options.condition,
      message = options.message;

  if (condition && isDev()) {
    console.warn(message);
  }
};

function runIfFn(valueOrFn) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return isFunction(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}

var isFunction = function isFunction(value) {
  return typeof value === "function";
};

var dataAttr = function dataAttr(condition) {
  return condition ? "" : void 0;
};

var ariaAttr = function ariaAttr(condition) {
  return condition ? true : void 0;
};

function callAllHandlers() {
  for (var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    fns[_key3] = arguments[_key3];
  }

  return function func(event) {
    fns.some(function (fn) {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}

function callAll() {
  for (var _len4 = arguments.length, fns = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    fns[_key4] = arguments[_key4];
  }

  return function mergedFn(arg) {
    fns.forEach(function (fn) {
      fn == null ? void 0 : fn(arg);
    });
  };
}

export { ariaAttr, callAll, callAllHandlers, cx, dataAttr, isObject, runIfFn, warn };